import { produce } from 'immer';
import {
  DELIVERYTYPE_SHIPPING,
  DELIVERYTYPE_STOREPICKUP,
} from '@krispsystems/constants';

import {
  PRINT_CONTROL_RECORD_DONE,
  PRINT_CONTROL_RECORD_ERROR,
  PRINT_CONTROL_RECORD_ERROR_CLEAR,
  PRINT_CONTROL_RECORD_IN_PROGRESS,
} from '../../constants/constant_oms';

const INIT_TYPE_STATE = {
  error: '',
  isError: false,
  isLoading: false,
};

const INIT_STATE = {
  [DELIVERYTYPE_SHIPPING]: {
    label: { ...INIT_TYPE_STATE },
    pack: { ...INIT_TYPE_STATE },
    pick: { ...INIT_TYPE_STATE },
    pickup: { ...INIT_TYPE_STATE },
    sale: { ...INIT_TYPE_STATE },
  },
  [DELIVERYTYPE_STOREPICKUP]: {
    label: { ...INIT_TYPE_STATE },
    pack: { ...INIT_TYPE_STATE },
    pick: { ...INIT_TYPE_STATE },
    pickup: { ...INIT_TYPE_STATE },
    sale: { ...INIT_TYPE_STATE },
  },
};

export default function omsPrintingReducer(state = INIT_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case PRINT_CONTROL_RECORD_DONE:
      case PRINT_CONTROL_RECORD_ERROR:
      case PRINT_CONTROL_RECORD_ERROR_CLEAR:
      case PRINT_CONTROL_RECORD_IN_PROGRESS: {
        const { payload } = action;
        const { deliveryType, types } = payload;

        for (const type of types) {
          draft[deliveryType][type] = omsPrintingTypeReducer(
            state[deliveryType][type],
            action
          );
        }
        break;
      }

      default:
        return state;
    }
  });
}

function omsPrintingTypeReducer(state = INIT_TYPE_STATE, action) {
  return produce(state, (draft) => {
    const { type, payload } = action || {};

    switch (type) {
      case PRINT_CONTROL_RECORD_IN_PROGRESS:
        draft.isLoading = true;
        draft.isError = false;
        draft.error = '';
        break;

      case PRINT_CONTROL_RECORD_ERROR:
        draft.isLoading = false;
        draft.isError = true;
        draft.error = payload.message;
        break;

      case PRINT_CONTROL_RECORD_DONE:
        draft.isLoading = false;
        draft.isError = false;
        draft.error = '';
        break;

      case PRINT_CONTROL_RECORD_ERROR_CLEAR:
        draft.isError = false;
        draft.error = '';
        break;

      default:
        return state;
    }
  });
}
